import { Autocomplete, GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import React, { useState } from 'react';
import { googleMapsApiKey } from '../../authorization/login';

const containerStyle = {
    width: '100%',
    height: '150px',
};

function DokanGoogleMaps() {
    const [autocomplete, setAutocomplete] = useState();
    const [location, setLocation] = useState();
    // eslint-disable-next-line no-unused-vars
    const [center, setCenter] = useState({
        lat: 23.836468,
        lng: 90.36953919999999,
    });

    const onLoad = (autoComplete) => {
        console.log('autocomplete: ', autoComplete);

        setAutocomplete(autoComplete);
    };

    const onPlaceChanged = () => {
        if (autocomplete !== null) {
            console.log(autocomplete.getPlace());
            console.log(autocomplete.getPlace().geometry.location.lng());
            setCenter({
                lat: autocomplete.getPlace().geometry.location.lat(),
                lng: autocomplete.getPlace().geometry.location.lng(),
            });
            setLocation(autocomplete.getPlace().formatted_address);
        } else {
            console.log('Autocomplete is not loaded yet!');
        }
    };

    return (
        <LoadScript googleMapsApiKey={googleMapsApiKey} libraries={['places']}>
            <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={16}>
                {/* Child components, such as markers, info windows, etc. */}

                <Autocomplete
                    onLoad={(autoComplete) => onLoad(autoComplete)}
                    onPlaceChanged={() => onPlaceChanged()}
                >
                    <input
                        type="text"
                        placeholder={location || ''}
                        style={{
                            boxSizing: `border-box`,
                            border: `1px solid transparent`,
                            width: `240px`,
                            height: `32px`,
                            padding: `0 12px`,
                            borderRadius: `3px`,
                            boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                            fontSize: `14px`,
                            outline: `none`,
                            textOverflow: `ellipses`,
                            position: 'absolute',
                            left: '50%',
                            marginLeft: '-120px',
                        }}
                    />
                </Autocomplete>
                <Marker onLoad={onLoad} position={center} />
            </GoogleMap>
        </LoadScript>
    );
}

export default React.memo(DokanGoogleMaps);
